import React from 'react';
import './Cms.scss';

type Props = {
  children: React.ReactNode;
};

function Cms({ children }: Props): JSX.Element {
  return <div className="cms">{children}</div>;
}

export default Cms;
